module.exports = __webpack_public_path__ + "334c591abe883b582b1d99a106680d74.svg";